// Psychology lessons — RE₿EL LLM pipeline translation (Sprint B).
// id keys preserved from ES.

export const LECCIONES_PSICOLOGIA = [
  {
    id: "los-7-errores",
    numero: 1,
    titulo: "摧毁账户的7个心理错误",
    duracion: "12分钟",
    descripcion: "95%的交易者都在亏钱。这不是因为缺乏技术知识——而是缺乏心理纪律。以下是最常见的7个心理错误以及如何避免它们。",
    contenido: [
      {
        tipo: "error",
        numero: 1,
        nombre: "FOMO（害怕错过）",
        descripcion: "因为价格已经大幅上涨而进场交易，害怕错过行情。结果：你在高点买入，成为价格下跌前最后一个进场的人。",
        sintomas: [
          "未经分析就进场",
          "价格已上涨>5%",
          "没有明确的止损计划",
          "感到紧迫"
        ],
        solucion: "接受总会有下一个机会。如果你没有在行情开始时进场，这笔交易已经不属于你了。等待下一个设置。",
        ejercicio: "下次感到FOMO时，在交易日志中写下：「价格已上涨X%。如果我现在进场，我的风险回报比是___」。如果风险回报比小于1:2，不要进场。"
      },
      {
        tipo: "error",
        numero: 2,
        nombre: "报复性交易",
        descripcion: "亏损后立即开启另一笔交易以挽回损失。你在情绪驱动下交易，而非策略驱动。结果：第二次亏损通常比第一次更大。",
        sintomas: [
          "刚刚亏损了一笔交易",
          "未等待设置就进场",
          "增加仓位大小",
          "感到愤怒或沮丧"
        ],
        solucion: "不可打破的规则：连续亏损2次后，当天停止交易。市场明天还在。",
        ejercicio: "实施2次止损规则：如果一天内触发2次止损，关闭交易平台。没有例外。"
      },
      {
        tipo: "error",
        numero: 3,
        nombre: "移动止损",
        descripcion: "价格接近止损时，你不让它触发，而是将其向下移动「希望它能恢复」。结果：1%的亏损变成5-10%的亏损。",
        sintomas: [
          "价格接近止损",
          "你想「再等一下」",
          "你已多次移动止损",
          "交易持续时间远超计划"
        ],
        solucion: "止损是神圣的。如果你在分析时将其设置在正确位置，就不要移动它。如果移动它，你的所有风险管理都变得毫无意义。",
        ejercicio: "在显示器上贴一张便条：「止损=计划。计划=止损。不要移动」。"
      },
      {
        tipo: "error",
        numero: 4,
        nombre: "过度交易",
        descripcion: "过度交易，不断寻找交易机会。无聊或兴奋导致进入低质量设置。更多交易=更多手续费=更多风险暴露=更多精神疲劳。",
        sintomas: [
          "一天内进行超过5笔交易",
          "主动寻找交易",
          "切换时间框架寻找设置",
          "无法没有持仓"
        ],
        solucion: "质量重于数量。定义每日最大交易次数（建议：2-3次）。如果达到了，就停止。最好的交易者做的交易很少但非常精选。",
        ejercicio: "记录所有交易。月底时，比较当天前几笔交易与最后几笔交易的胜率。你会发现最后几笔更差。"
      },
      {
        tipo: "error",
        numero: 5,
        nombre: "在止盈前退出",
        descripcion: "交易进展顺利，已盈利+3%，你决定在到达止盈前平仓，因为「已经赚够了」或害怕反转。结果：你的实际风险回报比是1:0.8而不是1:3。",
        sintomas: [
          "过早平仓盈利交易",
          "害怕利润消失",
          "你的平均盈利小于平均风险"
        ],
        solucion: "相信你的分析。如果你将止盈设置在有效的技术位，就让它运行。你可以使用部分平仓（在第一个目标平仓50%）来减少焦虑。",
        ejercicio: "在日志中记录你平仓的价格和实际达到的价格。量化因不遵守止盈而「留在桌上」的利润。"
      },
      {
        tipo: "error",
        numero: 6,
        nombre: "连胜后过度自信",
        descripcion: "连续5-6笔盈利交易后，你增加仓位大小或降低分析标准，因为「你在连胜」。骄傲总是在跌倒之前。永远如此。",
        sintomas: [
          "连续多笔盈利交易",
          "无理由增加仓位",
          "每笔交易分析减少",
          "感觉「不可能输」"
        ],
        solucion: "市场不知道你在连胜。每笔交易都是独立的。始终保持相同的风险百分比。",
        ejercicio: "提前定义何时增加仓位大小：只有当资金增长20%时。不要提前。"
      },
      {
        tipo: "error",
        numero: 7,
        nombre: "不遵守交易计划",
        descripcion: "你有计划但在交易时忽略它，因为「这次不同」。没有计划=没有纪律=没有持续的结果。计划不是建议，而是法律。",
        sintomas: [
          "临时改变策略",
          "凭直觉交易",
          "结果不一致",
          "没有书面规则"
        ],
        solucion: "将交易规则写在纸上并放在显示器前。每笔交易前，验证它符合所有条件。如果不符合，就没有交易。",
        ejercicio: "现在就写下你的交易计划：进场条件、止损、止盈、每日最大交易次数、最大风险资金。一页纸，简单规则，没有例外。"
      }
    ]
  },
  {
    id: "reglas-trading-personal",
    numero: 2,
    titulo: "如何创建你的个人交易规则",
    duracion: "8分钟",
    descripcion: "没有规则的交易者就是赌徒。专业交易者与亏损者之间的区别不是技术知识——而是在任何市场条件下遵守一套规则的纪律。",
    contenido_texto: "没有规则的交易者就是赌徒。专业交易者与亏损者之间的区别不是技术知识——而是在任何市场条件下遵守一套规则的纪律。\n\n你的规则必须包括：\n\n1. 进场标准\n   「我只在以下情况进场：[列出你的具体条件]」。\n   示例：「我只在上升趋势（4小时）中进场，在回调至订单块时，在15分钟确认CHoCH，最低风险回报比1:2」。\n\n2. 风险管理\n   • 我每笔交易的最大风险是X%。\n   • 我的每日最大亏损是X%。\n   • 如果我一周亏损X%，该周不再交易。\n\n3. 市场条件\n   • 重要新闻前30分钟不交易。\n   • 周一上午9点前不交易。\n   • 只在伦敦或纽约时段交易。\n\n4. 情绪管理\n   • 如果连续触发2次止损，当天停止交易。\n   • 每笔交易前检查计划。\n   • 如果疲劳、愤怒或压力大，不交易。\n\n5. 复盘与改进\n   • 每周日复盘本周所有交易。\n   • 每月计算统计数据：胜率、平均风险回报比、回撤。\n\n打印你的计划。贴在每天能看到的地方。每次交易前阅读。如果你坚持90天，你将成为一个不同的交易者。"
  },
  {
    id: "diario-emocional",
    numero: 3,
    titulo: "交易情绪日志",
    duracion: "6分钟",
    descripcion: "世界上最好的交易者都写日志。他们不仅记录数字（进场、出场、盈亏），还记录他们的心理状态。",
    contenido_texto: "世界上最好的交易者都写日志。他们不仅记录数字（进场、出场、盈亏），还记录他们的心理状态。\n\n日志条目模板：\n\n日期：_______________\n交易前情绪状态（1-10）：___\n备注：_______________\n\n交易\n• 交易对：___ — 方向：LONG / SHORT\n• 分析时间框架：___\n• 进场理由：_______________\n• 识别的设置：_______________\n• 进场：___  ·  止损：___  ·  止盈：___\n• 计算的风险回报比：___\n\n交易管理\n• 是否遵守计划？是/否\n• 如果否：为什么？_______________\n• 交易期间的情绪：_______________\n\n结果\n• 出场价格：___  ·  盈亏：___\n• 是否遵守止损？是/否\n• 是否遵守止盈？是/否\n\n交易教训\n• 做得好的地方？_______________\n• 需要改进的地方？_______________\n\n每笔交易都重复这个过程。50笔交易后，摧毁你账户的模式将一目了然。然后你就可以修正它们。"
  }
];
